import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const PostWrapper = styled.div`
  background-color: ${color.light};
  border: solid 1px ${color.gainsboro};
  border-bottom: none;
  margin: auto;
  max-width: 660px;

  > div {
    border-bottom: 1px solid #dadada!important;
  }

  @media ${device.laptop} {
    max-width: 1000px;
  }
`;

const GuestPostWrapper = styled.div`
  > div {
    padding: 0px;
    border-bottom: none;
  }
`;

export { PostWrapper, GuestPostWrapper };
